export default {
  all (context) {
    var params = {
      order: context.order
    }
    context.loading = true
    context.$http.get('promotions', {params: params}).then(response => {
      context.loading = false
      context.promotions = response.body.data
    })
  },
  get (context, id) {
    context.$http.get('promotions/' + id).then(response => {
      context.promotion = response.body.data[0]
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/promotions.js